import { enGB, nb } from 'date-fns/locale'
import { getPreferredLanguage } from '@/locale/util'

const locales: { [locale: string]: Locale } = { en: enGB, nb }

export function getLocale() {
  const locale = getPreferredLanguage()

  const ret = locales[locale] || locales['nb']

  // This should never happen
  if (!ret) throw new Error('Locale not found')

  return ret
}
